import { Paper, CardContent, Grid, Divider } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    borderRadius: 10,
    padding: theme.spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFF',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  photo: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    height: 60,
    width: 60,
    borderRadius: '50%',
    border: '1px solid #C0D9FF',
    marginRight: theme.spacing(2),
  },
  name: {
    marginLeft: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    textAlign: 'start',
    fontFamily: 'Montserrat',
    wordBreak: 'break-all',
  },
  address: {
    display: 'flex',
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(0.5),
    textAlign: 'start',
    alignItems: 'center',
  },
  infoContainer: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    textAlign: 'start',
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
    display: 'inline-block',
  },
  skeletonColor: {
    backgroundColor: '#D6E7FF !important',
    '&::after': {
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
    },
  },
  textArea: {
    borderRadius: 5,
    width: '100%',
    minHeight: 128,
    margin: theme.spacing(2, 0),
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    rowGap: 10,
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
}));

const PartnerCardSkeleton = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.cardContainer} elevation={0}>
      <CardContent style={{ textAlign: 'center', padding: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className={classes.photo}>
            <Skeleton variant="circle" width={60} height={60} className={classes.avatar + ' ' + classes.skeletonColor} />
            <Grid>
              <div className={classes.name}>
                <Skeleton variant="text" width={120} height={28} className={classes.skeletonColor} />
                <Skeleton variant="circle" width={18} height={18} className={classes.skeletonColor} style={{ marginLeft: 8 }} />
              </div>
              <div className={classes.address}>
                <Skeleton variant="circle" width={18} height={18} className={classes.skeletonColor} />
                <Skeleton variant="text" width={80} height={18} className={classes.skeletonColor} style={{ marginLeft: 8 }} />
              </div>
            </Grid>
          </div>
          <Skeleton variant="rect" width={40} height={40} className={classes.skeletonColor} style={{ borderRadius: 8 }} />
        </div>
        <Divider className={classes.divider} />
        <div className={classes.infoContainer}>
          <Skeleton variant="rect" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
          <Skeleton variant="text" width={120} height={18} className={classes.skeletonColor} />
        </div>
        <div className={classes.infoContainer}>
          <Skeleton variant="rect" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
          <Skeleton variant="text" width={120} height={18} className={classes.skeletonColor} />
        </div>
        <div className={classes.infoContainer}>
          <Skeleton variant="rect" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
          <Skeleton variant="text" width={120} height={18} className={classes.skeletonColor} />
        </div>
        <div className={classes.infoContainer}>
          <Skeleton variant="rect" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
          <Skeleton variant="text" width={120} height={18} className={classes.skeletonColor} />
        </div>
        <div className={classes.infoContainer}>
          <Skeleton variant="rect" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
          <Skeleton variant="text" width={120} height={18} className={classes.skeletonColor} />
        </div>
        <div className={classes.infoContainer}>
          <Skeleton variant="rect" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
          <Skeleton variant="text" width={120} height={18} className={classes.skeletonColor} />
        </div>
      </CardContent>
      <div className={classes.buttons}>
        <Skeleton variant="rect" width="100%" height={128} className={classes.skeletonColor + ' ' + classes.textArea} />
        <Skeleton variant="rect" width="100%" height={36} className={classes.skeletonColor} style={{ borderRadius: 10 }} />
      </div>
    </Paper>
  );
};

export default PartnerCardSkeleton; 